import React, { memo, useCallback, useMemo } from 'react';
import Box from '@wconcept/wconcept-ui-renewal/components/atoms/Box';
import QuickMenuBarType2 from '@wconcept/wconcept-ui-renewal/components/organisms/_list/QuickMenuBarType2';
import QuickMenuBtn2 from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/QuickMenuBtn2';
import { PromotionQuickBannerModule } from '@wconcept/wconcept-common/models/renewal/promotion';
import useLinkTo from '@hooks/useLinkTo';
import useGa4Event from '@hooks/useGa4Event';

interface QuickBannerModuleProps {
  modules: PromotionQuickBannerModule[];
  isMobile: boolean;
  contentTitle?: string;
}
const MO_ONE_ROW_MAX = 5;

function QuickBannerModule({
  modules,
  isMobile,
  contentTitle,
}: QuickBannerModuleProps) {
  const { linkTo } = useLinkTo();
  const { sendGa4BannerClick } = useGa4Event();

  const onClickBanner = useCallback(
    (module: PromotionQuickBannerModule, listNo: number) => {
      sendGa4BannerClick({
        page: 'promotion',
        area: 'promotion_shortcut_banner',
        text: module.mainTitle || undefined,
        listNo,
        variable: contentTitle || undefined,
        bannerType: module.ga4ClickEventResponse?.eventType,
        issueCd: module.ga4ClickEventResponse?.eventValue,
      });
      if (module.landingUrl) {
        linkTo.push({
          url: module.landingUrl,
        });
      }
    },
    [linkTo, sendGa4BannerClick, contentTitle]
  );

  const orderedModules = useMemo(() => {
    const indexed = modules.map((module, index) => ({
      module,
      listNo: index + 1,
    }));
    if (!isMobile || indexed.length <= MO_ONE_ROW_MAX) {
      return indexed;
    }
    return [
      ...indexed.filter((_, i) => i % 2 === 0),
      ...indexed.filter((_, i) => i % 2 !== 0),
    ];
  }, [modules, isMobile]);

  return (
    <Box as="section" className="corner-quick-menu">
      <QuickMenuBarType2
        isDesktop={!isMobile}
        items={orderedModules.map(({ module, listNo }) => (
          <QuickMenuBtn2
            key={module.moduleId}
            text={module.mainTitle}
            imgSrc={module.imageUrl}
            rs="150"
            onClick={() => onClickBanner(module, listNo)}
          />
        ))}
      />
    </Box>
  );
}

export default memo(QuickBannerModule);
